






import React, { useContext, useEffect, useState } from 'react'
import { apiGet } from '../../utils/apiFetch'
import apiPath from '../../utils/pathObj'
import OButton from 'components/reusable/OButton'
import ODateRangePicker from 'components/shared/datePicker/ODateRangePicker'
import dayjs from 'dayjs'
import Pagination from '../Pagination'
import AuthContext from 'context/AuthContext'
import { useTranslation } from 'react-i18next'
import AccountantOnboardingList from './AccountantOnboardingList'
import AccountantOnboardingEdit from './AccountantOnboardingEdit'
import AccountantOnboardingAdd from './AccountantOnboardingAdd'
import AccountantOnboardingView from './AccountantOnboardingView'
import helpers from 'utils/helpers'
import OSearch from 'components/reusable/OSearch'
import OnboardingGeoIps from 'components/geoAccess/OnboardingGeoIps'

const AccountantOnboardings = () => {
  // 1. ADDED fetchCompanyCompletionStatus HERE TO FIX ESLINT
  const { updatePageName, fetchCompanyCompletionStatus } = useContext(AuthContext)
  
  const { t } = useTranslation()
  const [page, setPage] = useState(1)
  const [pageSize] = useState(10)
  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10
  })
  const [accountantOnboardingList, setAccountantOnboardingList] = useState([])
  const [accountantAllOnboardingList, setAllAccountantOnboardingList] =
    useState([])
  const [accountantOnboardingAdd, setAccountantOnboardingAdd] = useState(false)
  const [accountantOnboardingEdit, setAccountantOnboardingEdit] =
    useState(false)
  const [currentItem, setCurrentItem] = useState('')
  const [accountantOnboardingView, setAccountantOnboardingView] =
    useState(false)
  const [isInitialized, setIsInitialized] = useState(false)
  const [subscriptionData, setSubscriptionData] = useState({})
  const [searchTerm, setSearchTerm] = useState('')
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('')

  const [sort, setSort] = useState({
    sortBy: 'createdAt',
    sortType: 'desc'
  })
  const [filterData, setFilterData] = useState({
    isReset: false,
    isFilter: false,
    category: '',
    searchKey: '',
    startDate: '',
    endDate: ''
  })
  const handleEdit = item => {
    setCurrentItem(item)
    setAccountantOnboardingEdit(!accountantOnboardingEdit)
  }

  const handleView = item => {
    setCurrentItem(item)
    setAccountantOnboardingView(!accountantOnboardingView)
  }

  const handleCategory = () => {
    setAccountantOnboardingAdd(!accountantOnboardingAdd)
  }

  const handlePageClick = event => {
    const newPage = event.selected + 1
    setPage(newPage)
  }

  const allOnboarding = async data => {
    try {
      const { category, startDate, endDate, searchKey, isFilter } = filterData
      
      // Handle page decrement on delete/status change
      let currentPage = page;
      if (
        (data?.deletePage && accountantOnboardingList?.length === 1 && page > 1) ||
        (isFilter && category && data?.statusChange && accountantOnboardingList?.length === 1 && page > 1)
      ) {
        currentPage = page - 1;
        setPage(currentPage);
        setPaginationObj({ ...paginationObj, page: currentPage });
      }

      const payload = {
        page: currentPage,
        pageSize,
        status: category,
        startDate: helpers?.ternaryCondition(
          startDate,
          dayjs(startDate).format('YYYY-MM-DD'),
          null
        ),
        endDate: helpers?.ternaryCondition(
          endDate,
          dayjs(endDate).format('YYYY-MM-DD'),
          null
        ),
        keyword: searchKey,
        sortBy: sort.sortBy,
        sortType: sort.sortType
      }
      const path = apiPath.accountantOnboardingList
      const result = await apiGet(path, payload)
      const response = result?.data?.results
      const resultStatus = result?.data?.success
      setAccountantOnboardingList(response?.docs)
      setPaginationObj({
        ...paginationObj,
        page: helpers?.ternaryCondition(resultStatus, response.page, null),
        pageCount: helpers?.ternaryCondition(
          resultStatus,
          response.totalPages,
          null
        ),
        perPageItem: helpers?.ternaryCondition(
          resultStatus,
          response?.docs.length,
          null
        ),
        totalItems: helpers?.ternaryCondition(
          resultStatus,
          response.totalDocs,
          null
        )
      })
    } catch (error) {
      console.log('error in get all accountant list==>>>>', error.message)
    }
  }

  const allWithoutOnboarding = async () => {
    try {
      const path = apiPath.accountantOnboardingList
      const result = await apiGet(path)
      const response = result?.data?.results
      const resultStatus = result?.data?.success
      setAllAccountantOnboardingList(response?.docs)
    } catch (error) {
      console.log('error in get all country list==>>>>', error.message)
    }
  }

  useEffect(() => {
    helpers.setDebouncingFunction({
      isInitialized,
      setIsInitialized,
      debouncedSearchTerm,
      searchTerm,
      filterData,
      setFilterData,
      setPage
    })
  }, [debouncedSearchTerm])

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm)
    }, 500)
    return () => {
      clearTimeout(timeoutId)
    }
  }, [searchTerm])

  useEffect(() => {
    updatePageName(t('ACCOUNTANT_ONBOARDING'))
  }, [])
  const handleReset = () => {
    setFilterData({
      searchKey: '',
      startDate: '',
      category: '',
      endDate: '',
      isReset: true,
      isFilter: false
    })
    setPage(1)
    setSearchTerm('')
  }

  const handleDateChange = (start, end) => {
    setPage(1)
    setFilterData({
      ...filterData,
      startDate: start,
      endDate: end,
      isFilter: true
    })
  }

  useEffect(() => {
    allWithoutOnboarding()
  }, [])

  useEffect(() => {
    allOnboarding()
  }, [page, filterData, sort])
  const statusPageList = e => {
    setFilterData({ ...filterData, category: e.target.value, isFilter: true })
    setPage(1)
  }
  const getSubscriptionList = async () => {
    try {
      const res = await apiGet(apiPath.getSubscription, {})
      setSubscriptionData(res?.data?.results)
    } catch (error) {
      console.log('error:', error)
    }
  }

  useEffect(() => {
    getSubscriptionList()
  }, [])

  return (
    <>
      {' '}
      <div className='bg-[#F9F9F9]'>
        <div className='px-3 py-4'>
          <div className='bg-white border border-[#E9EDF9] rounded-lg'>
            <form className='2xl:flex border-b border-b-[#E3E3E3] gap-2 px-4 py-3'>
              <div className='mb-2 col-span-2 flex flex-wrap  items-center 2xl:mb-0'>
                <div className='flex-wrap flex items-center lg:pt-0 pt-3 '>
                  <div className='mb-3 relative flex items-center '>
                    <OSearch
                      searchTerm={searchTerm}
                      setSearchTerm={setSearchTerm}
                      placeholder={t('O_SEARCH_BY_NAME')}
                    />
                  </div>
                  <ODateRangePicker
                    isReset={filterData?.isReset}
                    handleDateChange={handleDateChange}
                    setIsReset={setFilterData}
                  />
                  <div className='flex ml-3 mb-3 items-center'>
                    <select
                      className='bg-transparent block p-2 w-full text-sm text-[#A5A5A5] border-2 rounded-lg border-[#DFDFDF]  dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer'
                      placeholder=' '
                      id=''
                      name='category'
                      value={filterData?.category}
                      type='text '
                      onChange={e => statusPageList(e)}
                    >
                      <option value=''>
                        {t('O_ALL')}
                      </option>
                      <option value='active'>{t('O_ACTIVE')}</option>
                      <option value='inactive'>{t('O_INACTIVE')}</option>
                    </select>
                  </div>

                  <OButton
                    onClick={handleReset}
                    label='Reset'
                    style={{ borderRadius: '0.5rem' }}
                    type='button'
                    extraClasses='mb-3 ml-3 '
                  />
                </div>
              </div>
              <div className='px-4 ms-auto flex items-center justify-end mb-3'>
                <button
                  className='bg-LightBlue flex text-sm px-8 ml-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-DarkBlue disabled:hover:bg-[#3B82F680] whitespace-nowrap'
                  title='Add accountant onboarding'
                  type='button'
                  onClick={() => handleCategory()}
                >
                  + {t('ADD_ACCOUNTANT_ONBOARDING')}
                </button>
              </div>
            </form>
            <OnboardingGeoIps
              role='AccountantAdmin'
              title={t('GEO_SECTION_ACCOUNTANT')}
              help={t('GEO_SECTION_ACCOUNTANT_HELP')}
            />
            <AccountantOnboardingList
              accountantOnboardingList={accountantOnboardingList}
              allOnboarding={allOnboarding}
              page={page}
              handleEdit={handleEdit}
              handleView={handleView}
              currentItem={currentItem}
              setSort={setSort}
              sort={sort}
            />
            {accountantOnboardingView && (
              <AccountantOnboardingView
                accountantOnboardingView={accountantOnboardingView}
                currentItem={currentItem}
                handleView={handleView}
              />
            )}

            {accountantOnboardingEdit && (
              <AccountantOnboardingEdit
                handleEdit={handleEdit}
                currentItem={currentItem}
                allOnboarding={allOnboarding}
              />
            )}

            {/* 2. UNCOMMENTED AND ADDED refreshCompanyStatus PROPS HERE */}
            {accountantOnboardingAdd && (
              <AccountantOnboardingAdd
                allOnboarding={allOnboarding}
                accountantOnboardingAdd={accountantOnboardingAdd}
                handleCategory={handleCategory}
                setPage={setPage}
                refreshCompanyStatus={fetchCompanyCompletionStatus}
              />
            )}

            
            {helpers.ternaryCondition(
              paginationObj?.totalItems,
              <Pagination
                handlePageClick={handlePageClick}
                options={paginationObj}
                page={page}
              />,
              null
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default AccountantOnboardings


// import React, { useContext, useEffect, useState } from 'react'
// import { apiGet } from '../../utils/apiFetch'
// import apiPath from '../../utils/pathObj'
// import OButton from 'components/reusable/OButton'
// import ODateRangePicker from 'components/shared/datePicker/ODateRangePicker'
// import dayjs from 'dayjs'
// import Pagination from '../Pagination'
// import AuthContext from 'context/AuthContext'
// import { useTranslation } from 'react-i18next'
// import AccountantOnboardingList from './AccountantOnboardingList'
// import AccountantOnboardingEdit from './AccountantOnboardingEdit'
// import AccountantOnboardingAdd from './AccountantOnboardingAdd'
// import AccountantOnboardingView from './AccountantOnboardingView'
// import helpers from 'utils/helpers'
// import OSearch from 'components/reusable/OSearch'
// import OnboardingGeoIps from 'components/geoAccess/OnboardingGeoIps'

// const AccountantOnboardings = () => {
//   const { updatePageName } = useContext(AuthContext)
//   const { t } = useTranslation()
//   const [page, setPage] = useState(1)
//   const [pageSize] = useState(10)
//   const [paginationObj, setPaginationObj] = useState({
//     page: 1,
//     pageCount: 1,
//     pageRangeDisplayed: 10
//   })
//   const [accountantOnboardingList, setAccountantOnboardingList] = useState([])
//   const [accountantAllOnboardingList, setAllAccountantOnboardingList] =
//     useState([])
//   const [accountantOnboardingAdd, setAccountantOnboardingAdd] = useState(false)
//   const [accountantOnboardingEdit, setAccountantOnboardingEdit] =
//     useState(false)
//   const [currentItem, setCurrentItem] = useState('')
//   const [accountantOnboardingView, setAccountantOnboardingView] =
//     useState(false)
//   const [isInitialized, setIsInitialized] = useState(false)
//   const [subscriptionData, setSubscriptionData] = useState({})
//   const [searchTerm, setSearchTerm] = useState('')
//   const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('')

//   const [sort, setSort] = useState({
//     sortBy: 'createdAt',
//     sortType: 'desc'
//   })
//   const [filterData, setFilterData] = useState({
//     isReset: false,
//     isFilter: false,
//     category: '',
//     searchKey: '',
//     startDate: '',
//     endDate: ''
//   })
//   const handleEdit = item => {
//     setCurrentItem(item)
//     setAccountantOnboardingEdit(!accountantOnboardingEdit)
//   }

//   const handleView = item => {
//     setCurrentItem(item)
//     setAccountantOnboardingView(!accountantOnboardingView)
//   }

//   const handleCategory = () => {
//     setAccountantOnboardingAdd(!accountantOnboardingAdd)
//   }

//   const handlePageClick = event => {
//     const newPage = event.selected + 1
//     setPage(newPage)
//   }

//   const allOnboarding = async data => {
//     try {
//       const { category, startDate, endDate, searchKey, isFilter } = filterData
      
//       // Handle page decrement on delete/status change
//       let currentPage = page;
//       if (
//         (data?.deletePage && accountantOnboardingList?.length === 1 && page > 1) ||
//         (isFilter && category && data?.statusChange && accountantOnboardingList?.length === 1 && page > 1)
//       ) {
//         currentPage = page - 1;
//         setPage(currentPage);
//         setPaginationObj({ ...paginationObj, page: currentPage });
//       }

//       const payload = {
//         page: currentPage,
//         pageSize,
//         status: category,
//         startDate: helpers?.ternaryCondition(
//           startDate,
//           dayjs(startDate).format('YYYY-MM-DD'),
//           null
//         ),
//         endDate: helpers?.ternaryCondition(
//           endDate,
//           dayjs(endDate).format('YYYY-MM-DD'),
//           null
//         ),
//         keyword: searchKey,
//         sortBy: sort.sortBy,
//         sortType: sort.sortType
//       }
//       const path = apiPath.accountantOnboardingList
//       const result = await apiGet(path, payload)
//       const response = result?.data?.results
//       const resultStatus = result?.data?.success
//       setAccountantOnboardingList(response?.docs)
//       setPaginationObj({
//         ...paginationObj,
//         page: helpers?.ternaryCondition(resultStatus, response.page, null),
//         pageCount: helpers?.ternaryCondition(
//           resultStatus,
//           response.totalPages,
//           null
//         ),
//         perPageItem: helpers?.ternaryCondition(
//           resultStatus,
//           response?.docs.length,
//           null
//         ),
//         totalItems: helpers?.ternaryCondition(
//           resultStatus,
//           response.totalDocs,
//           null
//         )
//       })
//     } catch (error) {
//       console.log('error in get all accountant list==>>>>', error.message)
//     }
//   }

//   const allWithoutOnboarding = async () => {
//     try {
//       const path = apiPath.accountantOnboardingList
//       const result = await apiGet(path)
//       const response = result?.data?.results
//       const resultStatus = result?.data?.success
//       console.log('resultStatus', resultStatus)
//       setAllAccountantOnboardingList(response?.docs)
//     } catch (error) {
//       console.log('error in get all country list==>>>>', error.message)
//     }
//   }

//   useEffect(() => {
//     helpers.setDebouncingFunction({
//       isInitialized,
//       setIsInitialized,
//       debouncedSearchTerm,
//       searchTerm,
//       filterData,
//       setFilterData,
//       setPage
//     })
//   }, [debouncedSearchTerm])

//   useEffect(() => {
//     const timeoutId = setTimeout(() => {
//       setDebouncedSearchTerm(searchTerm)
//     }, 500)
//     return () => {
//       clearTimeout(timeoutId)
//     }
//   }, [searchTerm])

//   useEffect(() => {
//     updatePageName(t('ACCOUNTANT_ONBOARDING'))
//   }, [])
//   const handleReset = () => {
//     setFilterData({
//       searchKey: '',
//       startDate: '',
//       category: '',
//       endDate: '',
//       isReset: true,
//       isFilter: false
//     })
//     setPage(1)
//     setSearchTerm('')
//   }

//   const handleDateChange = (start, end) => {
//     setPage(1)
//     setFilterData({
//       ...filterData,
//       startDate: start,
//       endDate: end,
//       isFilter: true
//     })
//   }

//   useEffect(() => {
//     allWithoutOnboarding()
//   }, [])

//   useEffect(() => {
//     allOnboarding()
//   }, [page, filterData, sort])
//   const statusPageList = e => {
//     setFilterData({ ...filterData, category: e.target.value, isFilter: true })
//     setPage(1)
//   }
//   const getSubscriptionList = async () => {
//     try {
//       const res = await apiGet(apiPath.getSubscription, {})
//       setSubscriptionData(res?.data?.results)
//     } catch (error) {
//       console.log('error:', error)
//     }
//   }

//   useEffect(() => {
//     getSubscriptionList()
//   }, [])

//   return (
//     <>
//       {' '}
//       <div className='bg-[#F9F9F9]'>
//         <div className='px-3 py-4'>
//           <div className='bg-white border border-[#E9EDF9] rounded-lg'>
//             <form className='2xl:flex border-b border-b-[#E3E3E3] gap-2 px-4 py-3'>
//               <div className='mb-2 col-span-2 flex flex-wrap  items-center 2xl:mb-0'>
//                 <div className='flex-wrap flex items-center lg:pt-0 pt-3 '>
//                   <div className='mb-3 relative flex items-center '>
//                     <OSearch
//                       searchTerm={searchTerm}
//                       setSearchTerm={setSearchTerm}
//                       placeholder={t('O_SEARCH_BY_NAME')}
//                     />
//                   </div>
//                   <ODateRangePicker
//                     isReset={filterData?.isReset}
//                     handleDateChange={handleDateChange}
//                     setIsReset={setFilterData}
//                   />
//                   <div className='flex ml-3 mb-3 items-center'>
//                     <select
//                       className='bg-transparent block p-2 w-full text-sm text-[#A5A5A5] border-2 rounded-lg border-[#DFDFDF]  dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer'
//                       placeholder=' '
//                       id=''
//                       name='category'
//                       value={filterData?.category}
//                       type='text '
//                       onChange={e => statusPageList(e)}
//                     >
//                       <option value=''>
//                         {t('O_ALL')}
//                       </option>
//                       <option value='active'>{t('O_ACTIVE')}</option>
//                       <option value='inactive'>{t('O_INACTIVE')}</option>
//                     </select>
//                   </div>

//                   <OButton
//                     onClick={handleReset}
//                     label='Reset'
//                     style={{ borderRadius: '0.5rem' }}
//                     type='button'
//                     extraClasses='mb-3 ml-3 '
//                   />
//                 </div>
//               </div>
//               <div className='px-4 ms-auto flex items-center justify-end mb-3'>
//                 <button
//                   className='bg-LightBlue flex text-sm px-8 ml-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-DarkBlue disabled:hover:bg-[#3B82F680] whitespace-nowrap'
//                   // disabled={
//                   //   filterData?.category === 'inactive' ||
//                   //   subscriptionData?.noOfAccountant <=
//                   //     accountantAllOnboardingList?.length
//                   // }
//                   title='Add accountant onboarding'
//                   type='button'
//                   onClick={() => handleCategory()}
//                 >
//                   + {t('ADD_ACCOUNTANT_ONBOARDING')}
//                 </button>
//               </div>
//             </form>
//             <OnboardingGeoIps
//               role='AccountantAdmin'
//               title={t('GEO_SECTION_ACCOUNTANT')}
//               help={t('GEO_SECTION_ACCOUNTANT_HELP')}
//             />
//             <AccountantOnboardingList
//               accountantOnboardingList={accountantOnboardingList}
//               allOnboarding={allOnboarding}
//               page={page}
//               handleEdit={handleEdit}
//               handleView={handleView}
//               currentItem={currentItem}
//               setSort={setSort}
//               sort={sort}
//             />
//             {accountantOnboardingView && (
//               <AccountantOnboardingView
//                 accountantOnboardingView={accountantOnboardingView}
//                 currentItem={currentItem}
//                 handleView={handleView}
//               />
//             )}

//             {accountantOnboardingEdit && (
//               <AccountantOnboardingEdit
//                 handleEdit={handleEdit}
//                 currentItem={currentItem}
//                 allOnboarding={allOnboarding}
//               />
//             )}

//             {/* {accountantOnboardingAdd && (
//               <AccountantOnboardingAdd
//                 allOnboarding={allOnboarding}
//                 accountantOnboardingAdd={accountantOnboardingAdd}
//                 handleCategory={handleCategory}
//                 setPage={setPage}
//               />
//             )} */}

            
//             {helpers.ternaryCondition(
//               paginationObj?.totalItems,
//               <Pagination
//                 handlePageClick={handlePageClick}
//                 options={paginationObj}
//                 page={page}
//               />,
//               null
//             )}
//           </div>
//         </div>
//       </div>
//     </>
//   )
// }

// export default AccountantOnboardings
